<script setup lang="ts">
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge'
import thumbnail from '@/assets/images/thumbnail-app-4.png'

definePage({
  path: '/auth/redirect',
  name: 'auth.redirect',
  meta: {
    layout: 'empty',
    allowAnonymous: true,
    isAuthRedirect: true,
  },
})

/*
 * MSAL v5 requires this redirectUri page to relay the auth response back to the main frame when
 * it's loaded inside a popup/hidden iframe (used by silent/COOP-isolated flows). Without it,
 * acquireTokenSilent's iframe fallback times out with BrowserAuthError "timed_out"
 * (redirect_bridge_timeout) instead of resolving or throwing InteractionRequiredAuthError.
 */
broadcastResponseToMainFrame().catch(console.error)
</script>

<template>
  <main class="h-100dvh flex grow flex-col items-center gap-y-10 bg-[#fafafa] py-5">
    <img
      :src="thumbnail" alt="Logo"
      class="item-container w-100 rounded-lg object-cover shadow-md"
    >

    <section class="item-container w-100">
      <Card>
        <template #content>
          <div class="flex flex-col items-center gap-y-7.5">
            <section class="flex flex-col items-center gap-y-5 text-center">
              <h1>
                Bezig met inloggen
              </h1>

              <p class="max-w-lg leading-tight !px-5">
                Wacht even terwijl we je doorsturen naar de juiste pagina.
              </p>
            </section>
          </div>
        </template>
      </Card>
    </section>

    <section class="flex flex-auto flex-col items-center flex-justify-end">
      <AppFooter class="mt-0! pt-0!" />
    </section>
  </main>
</template>

<style scoped>

</style>
